export default __webpack_public_path__ + "static/media/artboard-16.f106a3aa.svg";